import api, { realTimeApiInstance } from '../../services/api';
import { createWrapperPayload, wrapperConstants } from '../../services/wrapper-api';

export const getTier1DailySummary = async (assetId?: string | null) => {
  if (!assetId) return [];

  try {
    const response: any = await realTimeApiInstance.get(`/RealTimeData/GetWellShutDownSummary/${assetId}`);

    return response?.data ?? [];
  } catch (error) {
    console.error('Error fetching tier 1 daily summary data', error);
    return [];
  }
};

export const getTier2DailyDowntimes = async (wellId?: number | null) => {
  if (!wellId) return null;
  const req = createWrapperPayload('GET', `/pumpchecker/api/v1/Downtime/dailyDowntimes/${wellId}`);
  const resp = await api.post(wrapperConstants.router, req);
  // wrapper may return array directly or { value: [...] }
  return resp?.data ?? resp?.data?.value ?? null;
};

export default {
  getTier1DailySummary,
  getTier2DailyDowntimes,
};
